import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import FormDateTimePicker from "app/Components/_form/FormDatePicker/FormDateTimePicker";
import SingleFileUpload from "app/views/custom/components/FileUpload/SingleFileUpload";
import { disableFutureDate } from "app/_helpers/dateHelper";
import { useForm } from "app/_helpers/hooks";
import React, { useState } from "react";
import { Button, Col, Modal } from "react-bootstrap";
import toastr from "toastr";

const initialForm = {
  comment: "",
  trainingCompleteDate: "",
  feedbackTestFile: null,
  feedbackTestFileId: null,
  otherTrainingCertificateId: null,
  otherCertificateFile: null,
};

function TrainingCompletedForm(props) {
  const [show, setShow] = useState(false);
  const [form, onChange, setForm] = useForm({
    ...initialForm,
    trainingCompleteDate: props?.batchData?.trainingDate,
  });
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onDecline = async () => {
    if (form.comment == "" || !form.comment.trim()) {
      toastr.warning("Comment is Required!");
      return false;
    }

    props.onSubmit(form);
    handleClose();
    // let response = await declineRow(props.id, data);
    // if(response.status === 1){
    //     history.push("/health-safety-and-environment/incident-management/manage-incidents");
    // }
  };

  const onFileChange = (_event, responseData) => {
    setForm((prev) => ({
      ...prev,
      feedbackTestFileId: responseData?.id,
      feedbackTestFile: responseData,
    }));
  };
  const deleteDocumentFile = (_event, _index) => {
    setForm((prev) => ({ ...prev, feedbackTestFileId: null, feedbackTestFile: null }));
  };

  const onFileChange1 = (_event, responseData) => {
    setForm((prev) => ({
      ...prev,
      otherTrainingCertificateId: responseData?.id,
      otherCertificateFile: responseData,
    }));
  };
  const deleteDocumentFile1 = (_event, _index) => {
    setForm((prev) => ({
      ...prev,
      otherTrainingCertificateId: null,
      otherCertificateFile: null,
    }));
  };

  // console.log('props.id', props.batchData);
  // console.log('+++++', form);

  return (
    <>
      <span
        className={props.iconClass ? props.iconClass : "pointer btn btn-right"}
        onClick={handleShow}
      >
        {props.name ? props.name : "Decline"}
      </span>

      <Modal backdrop="static" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{props.title ? props.title : "Decline Report"} </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <Col lg={props?.isOtherTraining ? 12 : 6}>
              <div className="form-group viewbox">
                <label className="w-500 mb-1">Completion Date</label>
                <DatePicker
                  name="trainingCompleteDate"
                  value={form?.trainingCompleteDate}
                  onChange={(moment, name) =>
                    typeof moment !== "string" &&
                    onChange({ target: { name, value: moment.format("YYYY-MM-DD") } })
                  }
                  //isValidDate={disableFutureDate}
                />
                {/* <span className="small text-danger">{errorForm.completionDate}</span> */}
              </div>
            </Col>
            <Col lg={6}>
              <div className="form-group viewbox">
                <label>Feedback/Test</label>
                <SingleFileUpload
                  clsName="form-group"
                  alias={false}
                  //disabled={form?.eventStatus == "planned" ? true : false}
                  labelName=" "
                  selectedFile={form.feedbackTestFile}
                  deleteDocumentFile={() => deleteDocumentFile()}
                  onFileChange={onFileChange}
                />
                {/* <span className="small text-danger">{errorForm.completionProofId}</span> */}
              </div>
            </Col>
            {props?.isOtherTraining && (
              <Col lg={6}>
                <div className="form-group viewbox">
                  <label>Training Certificate</label>
                  <SingleFileUpload
                    clsName="form-group"
                    alias={false}
                    //disabled={form?.eventStatus == "planned" ? true : false}
                    labelName=" "
                    selectedFile={form?.otherCertificateFile}
                    deleteDocumentFile={() => deleteDocumentFile1()}
                    onFileChange={onFileChange1}
                  />
                  {/* <span className="small text-danger">{errorForm.completionProofId}</span> */}
                </div>
              </Col>
            )}
            <div className="col-md-12">
              <label>Comment</label>
              <textarea
                className="form-control"
                placeholder="Comment"
                name="comment"
                value={form?.comment}
                onChange={onChange}
              ></textarea>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => onDecline()}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TrainingCompletedForm;
